import React from "react";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import HubIcon from '@mui/icons-material/Hub';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ShieldIcon from '@mui/icons-material/Shield';
import '../assets/styles/Services.scss';

interface Service {
  icon: React.ReactNode;
  title: string;
  description: string;
  tags: string[];
}

const services: Service[] = [
  {
    icon: <AttachMoneyIcon />,
    title: "AWS Cost Optimization",
    description: "Audit and optimize AWS spend through rightsizing, Karpenter Spot integration, Savings Plans, and FinOps implementation. Post-migration environments typically yield 20–40% cost reduction within 60 days.",
    tags: ["FinOps", "Karpenter", "Savings Plans", "Rightsizing"],
  },
  {
    icon: <HubIcon />,
    title: "Kubernetes Architecture",
    description: "Design and operate production EKS clusters — from node group strategy and autoscaling to GitOps pipelines, custom networking (Envoy, CNI), and multi-tenancy patterns.",
    tags: ["EKS", "GitOps", "ArgoCD", "Karpenter", "Envoy"],
  },
  {
    icon: <AccountTreeIcon />,
    title: "Cloud-Native Architecture",
    description: "Architect systems from the ground up with scalability, security, and operational simplicity built in. Tech selection, ADRs, system design, and hands-on implementation leadership.",
    tags: ["System Design", "Terraform", "Multi-Region", "Microservices"],
  },
  {
    icon: <ShieldIcon />,
    title: "Reliability & Observability",
    description: "Build observability foundations with Prometheus, Grafana, and distributed tracing. Design for failure: DR strategies, incident runbooks, SLOs, and resilience patterns.",
    tags: ["Prometheus", "Grafana", "SLOs", "Disaster Recovery"],
  },
];

function Services() {
  return (
    <div className="container" id="services">
      <div className="services-container">
        <div className="services-header">
          <span className="services-tag">{'// What I Do'}</span>
          <h1>Four areas of deep expertise.</h1>
          <p className="services-subtitle">
            Where I bring the most impact — from day one of an engagement.
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h2>{service.title}</h2>
              <p>{service.description}</p>
              <div className="service-tags">
                {service.tags.map((tag, i) => (
                  <span key={i} className="service-tag">{tag}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services;
